import { AuthGroup, Condition, ResultSetHeader } from '../../models';
import http from '../http';

export default {
    // 获取单个权限组信息
    async get_auth_group_id(params: Pick<AuthGroup, '_id'> & { string_id: string }): Promise<AuthGroup> {
        const { string_id, _id } = params;
        return await http.get(`/group/string_id/${string_id}/auth_group/id/${_id}`);

    },

    // 筛查指定集团的权限组
    async get_auth_group(params: { string_id: string } & Condition): Promise<{ dbResults: Array<AuthGroup>; totalCount: Array<any> }> {
        const { string_id, ...rest } = params;
        return await http.get(`/group/string_id/${string_id}/auth_group`, {
            params: {
                ...rest
            },
        })

    },


    // 创建权限组
    async create_auth_group(params: AuthGroup & { string_id: string }): Promise<ResultSetHeader> {
        const { string_id, ...rest } = params;
        return await http.post(`/group/string_id/${string_id}/auth_group`, { ...rest });
    },

    // 复制权限组
    async copy_auth_group_by_id(params: Pick<AuthGroup, '_id' | 'name'> & { string_id: string }): Promise<ResultSetHeader> {
        const { string_id, _id, ...rest } = params;
        return await http.post(`/group/string_id/${string_id}/auth_group/id/${_id}`, { ...rest })
    },

    // 删除权限组
    async delete_auth_group_id(params: Pick<AuthGroup, '_id'> & { string_id: string }): Promise<ResultSetHeader> {
        const { string_id, _id } = params;
        return await http.delete(`/group/string_id/${string_id}/auth_group/_id/${_id}`);
    },

    // 修改权限组
    async patch_auth_group_id(params: AuthGroup & { string_id: string }): Promise<ResultSetHeader> {
        const { string_id, _id, ...rest } = params;
        return await http.patch(`/group/string_id/${string_id}/auth_group/_id/${_id}`, { ...rest })
    },

    // Staff账号应用权限组
    async patch_staff_auth_group_id(params: { auth_group_id: string, staff_id: string }): Promise<ResultSetHeader> {
        const { auth_group_id, staff_id } = params;
        return await http.patch(`/staff/id/${staff_id}/auth_group/id/${auth_group_id}`)
    },

    // staff修改权限
    async patch_modify_staff_auth(params: AuthGroup): Promise<ResultSetHeader> {
        const { _id, ...rest } = params;
        return await http.patch(`/staff/id/${_id}/auth`, { ...rest });
    },

}